import { api } from "../../api/api";
import {
  COUNT_OF_EACH_CONTENT_REQ,
  COUNT_OF_EACH_CONTENT_SUCCESS,
  COUNT_STATS_OF_SCREEN_REQ,
  COUNT_STATS_OF_SCREEN,
  COUNT_OF_PLAYLIST_REQ,
  COUNT_OF_PLAYLIST_SUCCESS,
} from "../constant";

export const getDashboardStats = (userId) => {
  return async (dispatch) => {
    if (!userId) return;

    dispatch({ type: COUNT_OF_EACH_CONTENT_REQ, payload: "" });
    dispatch({ type: COUNT_STATS_OF_SCREEN_REQ, payload: "" });
    dispatch({ type: COUNT_OF_PLAYLIST_REQ, payload: 0 });

    try {
      const [contentRes, screenRes, playlistRes] = await Promise.all([
        api.get(`/content/countofeachcontent/${userId}`).catch(() => null),
        api.get(`/screen/countstatsofscreen/${userId}`).catch(() => null),
        api.get(`/playlist/countofplaylist/${userId}`).catch(() => null),
      ]);

      dispatch({
        type: COUNT_OF_EACH_CONTENT_SUCCESS,
        payload: contentRes?.data?.counts || { total: 0 },
      });
      dispatch({
        type: COUNT_STATS_OF_SCREEN,
        payload: screenRes?.data?.screen_stats || { online: 0, offline: 0, total: 0 },
      });
      dispatch({
        type: COUNT_OF_PLAYLIST_SUCCESS,
        payload: playlistRes?.data?.playlistcount || 0,
      });
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
      dispatch({ type: COUNT_OF_EACH_CONTENT_SUCCESS, payload: { total: 0 } });
      dispatch({ type: COUNT_STATS_OF_SCREEN, payload: { online: 0, offline: 0, total: 0 } });
      dispatch({ type: COUNT_OF_PLAYLIST_SUCCESS, payload: 0 });
    }
  };
};
